"use strict";

var _defineProperty = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/defineProperty.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClassName = void 0;
var markdown_module_css_1 = __importDefault(require("@vtblife/react-markdown-styles/dist/markdown.module.css"));
var react_markdown_types_1 = require("@vtblife/react-markdown-types");
var classnames_1 = __importDefault(require("classnames"));
var react_markdown_utils_1 = require("@vtblife/react-markdown-utils");
function buildClassName(_ref) {
  var _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? false : _ref$footnote,
    _ref$imageSize = _ref.imageSize,
    imageSize = _ref$imageSize === void 0 ? react_markdown_types_1.ImageSizeType.Original : _ref$imageSize,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? markdown_module_css_1.default : _ref$styles,
    _ref$unorderedListSty = _ref.unorderedListStyle,
    unorderedListStyle = _ref$unorderedListSty === void 0 ? react_markdown_types_1.MarkdownUnorderedListStyle.Dot : _ref$unorderedListSty,
    breakpoints = _ref.breakpoints;
  var _a, _b, _c;
  var breakpointsClassNames = react_markdown_utils_1.getBreakpointsClassNames({
    breakpoints: breakpoints,
    mappers: {
      colorVariant: function colorVariant(_colorVariant) {
        var classes = [];
        if (footnote) {
          classes.push("markdown-content-footnote-".concat(_colorVariant));
        } else {
          if (!inline) {
            classes.push("".concat(_colorVariant, "-variant"));
          }
        }
        return classes;
      },
      sizeVariant: function sizeVariant(_sizeVariant) {
        return !footnote ? ["markdown-content-".concat(_sizeVariant)] : null;
      },
      paddingSize: function paddingSize(_paddingSize) {
        return ["markdown-padding-size-".concat(_paddingSize)];
      }
    }
  });
  return classnames_1.default((_a = breakpointsClassNames.colorVariant) === null || _a === void 0 ? void 0 : _a.map(function (className) {
    return styles[className];
  }), (_b = breakpointsClassNames.paddingSize) === null || _b === void 0 ? void 0 : _b.map(function (className) {
    return styles[className];
  }), (_c = breakpointsClassNames.sizeVariant) === null || _c === void 0 ? void 0 : _c.map(function (className) {
    return styles[className];
  }), styles["markdown-unordered-list-".concat(unorderedListStyle)], _defineProperty({}, styles.imageFullWidth, imageSize === react_markdown_types_1.ImageSizeType.FullWidth));
}
exports.buildClassName = buildClassName;